import { Bar } from "react-chartjs-2";
import { ChartData } from "chart.js";
import {
  SMALL_BAR_OPTIONS,
  getExpectedRatios,
  combineGroupedHistograms,
  GROUND_COLOR_PALETTE,
} from "./insights-page-utils";
import { BirdBowlData } from "../../types/bird/bird-bowl-data";

interface Props {
  readonly historicUpdates: BirdBowlData[];
}

export default function ExpectedHistorics({ historicUpdates }: Props) {
  const groupedStrikeRates = getExpectedRatios(historicUpdates, "strikeRate");
  const groupedWicketPercents = getExpectedRatios(historicUpdates, "wicketPercent");

  const strikeRateHistogram: ChartData<"bar"> = combineGroupedHistograms(
    groupedStrikeRates,
    "Strike Rate",
    GROUND_COLOR_PALETTE
  );

  const wicketPercentHistogram: ChartData<"bar"> = combineGroupedHistograms(
    groupedWicketPercents,
    "Wicket %",
    GROUND_COLOR_PALETTE
  );

  return (
    <>
      <div style={{ marginBottom: "1rem" }}>
        <h4 className="insights-page-header-4">Expected Strike Rates at this Ground</h4>
        <div style={{ height: "280px" }}>
          <Bar data={strikeRateHistogram} options={SMALL_BAR_OPTIONS} />
        </div>
      </div>
      <div>
        <h4 className="insights-page-header-4">Expected Wicket Percentages at this Ground</h4>
        <div style={{ height: "280px" }}>
          <Bar data={wicketPercentHistogram} options={SMALL_BAR_OPTIONS} />
        </div>
      </div>
    </>
  );
}